var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockTracking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43403_132334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.625C6.14026 0.625 4.81105 1.02821 3.68046 1.78365C2.54987 2.53908 1.66868 3.61281 1.14833 4.86905C0.627979 6.12529 0.491831 7.50763 0.757104 8.84125C1.02238 10.1749 1.67716 11.3999 2.63864 12.3614C3.60013 13.3228 4.82514 13.9776 6.15876 14.2429C7.49238 14.5082 8.87471 14.372 10.131 13.8517C11.3872 13.3313 12.4609 12.4501 13.2164 11.3195C13.9718 10.189 14.375 8.85975 14.375 7.5C14.3729 5.6773 13.6478 3.92986 12.359 2.64102C11.0701 1.35217 9.32271 0.62715 7.5 0.625ZM9.81688 9.81687C9.69967 9.93404 9.54073 9.99987 9.375 9.99987C9.20928 9.99987 9.05033 9.93404 8.93313 9.81687L7.05813 7.94187C6.94091 7.82469 6.87504 7.66575 6.875 7.5V3.75C6.875 3.58424 6.94085 3.42527 7.05806 3.30806C7.17527 3.19085 7.33424 3.125 7.5 3.125C7.66576 3.125 7.82473 3.19085 7.94194 3.30806C8.05915 3.42527 8.125 3.58424 8.125 3.75V7.24125L9.81688 8.93313C9.93405 9.05033 9.99987 9.20927 9.99987 9.375C9.99987 9.54073 9.93405 9.69967 9.81688 9.81687Z",
    fill: "#8E8E8E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43403_132334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockTracking);
export default __webpack_public_path__ + "static/media/ClockTracking.548ea23ab8bca9095e8556057f599a82.svg";
export { ForwardRef as ReactComponent };